import React from 'react';
import { useGetOptions, AutocompleteOption } from "../../../../../hooks/report/useGetOptions";
import { BoundAutocomplete } from "../BoundAutocomplete";
import { AssetTypeLabel } from "../../../../constants/securspace-constants";

type BoundAssetTypeAutocompleteProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundAssetTypeAutocomplete = <T,>({
  label = "Asset Type",
  name,
  value = '',
  onChange
}: BoundAssetTypeAutocompleteProps<T>) => {

  return <BoundAutocomplete<T>
    options={useGetOptions({optionFormat: 'AUTOCOMPLETE', options: AssetTypeLabel}) as unknown as AutocompleteOption[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundAssetTypeAutocomplete };